<template>
  <div>
    <options-light-list :options="companyOptions"></options-light-list>
  </div>
</template>

<script>
export default {
  name: 'CompanyOptions',
  components: {
    OptionsLightList: () => import('@/components/options/OptionsLightList')
  },
  props: {
    companyOptions: {
      type: Array
    }
  }
}
</script>
